import { createRouter, createWebHistory } from 'vue-router';
import Home from '../views/Home.vue';

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/crawl-settings',
    name: 'CrawlSettings',
    component: () => import('../views/CrawlSettings.vue')
  },
  {
    path: '/crawl-projects',
    name: 'CrawlProjects',
    component: () => import('../views/CrawlProjects.vue')
  },
  {
    path: '/apply-settings',
    name: 'ApplySettings',
    component: () => import('../views/ApplySettings.vue')
  },
  {
    path: '/applied-projects',
    name: 'AppliedProjects',
    component: () => import('../views/AppliedProjects.vue')
  },
  {
    path: '/auto-apply-schedule',
    name: 'AutoApplySchedule',
    component: () => import('../views/AutoApplySchedule.vue')
  },
  {
    path: '/about',
    name: 'About',
    component: () => import('../views/About.vue')
  },
  {
    path: '/project-types',
    name: 'ProjectTypes',
    component: () => import('../views/ProjectTypes.vue')
  }
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
});

export default router;
